import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../components/ui.module';

type CellParams = ICellRendererParams & {
  isEditing: () => boolean;
  isSaving: () => boolean;
  editEnable: () => void;
  editCancel: () => void;
  editSave: () => void;
};

@Component({
  selector: 'app-cell-subscriptions-actions-header',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule],
  templateUrl: './cell-subscriptions-actions-header.component.html',
  styleUrl: './cell-subscriptions-actions-header.component.scss',
})
export class CellSubscriptionsActionsHeaderComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
